import React from 'react'
import DatabaseStructureTest from '../components/test/DatabaseStructureTest'

const DatabaseStructureTestPage: React.FC = () => {
  return <DatabaseStructureTest />
}

export default DatabaseStructureTestPage